module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "inbox"
    }
  }, [(!_vm.isLoggedIn) ? _c('div', [_c('div', {
    staticClass: "not-logged"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/Login"
    }
  }, [_vm._v("Log in")]), _vm._v(" to view your inbox.")], 1)])]) : _c('div', [_c('ul', {
    attrs: {
      "id": "section-switcher"
    }
  }, [(!_vm.composeView) ? _c('li', {
    staticClass: "selected"
  }, [_c('span', [_vm._v("Inbox")])]) : _c('li', [_c('router-link', {
    attrs: {
      "to": "/Inbox",
      "title": "Compose"
    }
  }, [_vm._v("Inbox")])], 1), _vm._v(" "), (_vm.composeView) ? _c('li', {
    staticClass: "selected"
  }, [_c('span', [_vm._v("Compose New")])]) : _c('li', [_c('router-link', {
    attrs: {
      "to": "/Inbox/Compose",
      "title": "Compose"
    }
  }, [_vm._v("Compose New")])], 1)]), _vm._v(" "), (_vm.inboxView) ? _c('section', {
    attrs: {
      "id": "conversations"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.conversations), function(conversation) {
    return _c('router-link', {
      class: {
        unread: !conversation.hasBeenRead
      },
      attrs: {
        "to": ("/Inbox/" + (conversation.id))
      }
    }, [_c('span', [_vm._v(_vm._s(conversation.subject))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("joinArray")(conversation.participants, 'alias')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(conversation.lastMessageDate)))])])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.inboxView && !_vm.composeView) ? _c('inbox-conversation') : _vm._e(), _vm._v(" "), (_vm.composeView) ? _c('inbox-compose') : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('span', [_vm._v("Subject")]), _vm._v(" "), _c('span', [_vm._v("Participants")]), _vm._v(" "), _c('span', [_vm._v("Last Message")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dd5cb9f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Inbox/InboxHome.vue
// module id = 856
// module chunks = 2